<template>
  <div>
    <ul>
      <li v-for="(tempAttachment, index) in tempAttachments"
          :key="tempAttachment._id"
      >
        <div class="file-details">
          <div class="file-name d-flex flex-row align-center justify-space-between">
            <p class="text-overflow mb-1" ref="attachmentTitle">{{ tempAttachment.title }}</p>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-2" icon v-bind="attrs" v-on="on" @click="$emit('removetempfile', index)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Supprimer ce document de mon dossier.</span>
            </v-tooltip>
          </div>
          <div class="file-info">
            <span class="uploaded-date"> {{ tempAttachment.size }} bytes </span>
            <span v-if="checkProgress(tempAttachment)" class="upload-progress">
              {{ `${tempAttachment.progress} %` }}
            </span>
          </div>
        </div>
      </li>
      <li v-for="(item, index) in existingAttachments" :key="index">
        <div class="file-details">
          <div class="file-name d-flex flex-row align-center justify-space-between">
            <p class="text-overflow mb-1" ref="attachmentTitle">{{ item.label }}</p>
            <v-tooltip bottom v-if="!existingAttachments.includes(item)">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-2" icon v-bind="attrs" v-on="on" @click="$emit('removeuploadedfile', item)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Supprimer ce document de mon dossier.</span>
            </v-tooltip>
          </div>
          <div class="file-info">
            <span class="uploaded-date"> inconnu </span>
            <span class="upload-progress"> Completed </span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["tempAttachments", "attachments", "existingAttachments"],
  methods: {
    checkProgress(attachment) {
      return attachment.progress === null ? false : true
    },
  },
}
</script>

<style scoped>
.text-overflow {
  text-overflow: ellipsis;
  overflow: hidden;
}

ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0px;
}
li {
  border: 1px solid;
  margin-bottom: 8px;
  border-radius: 8px;
  margin-right: 8px;
  padding: 0 0 0 10px;
}
.file-name {
  min-width: 150px;
  font-size: 13px;
}
.uploaded-date {
  font-size: 12px;
}
.upload-progress {
  font-size: 12px;
}
.file-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>